import { Box, Button, Divider, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { FC, useEffect, useMemo } from "react";

import __ from "web/Layout/Translations";

import FieldMUI from "web/Components/Common/Form/Field/fieldMUI";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";
import {
  getFieldSpecificProps,
  getInitialValues,
} from "web/utils/page/product/subscription/forms/prepareFormData";
import { validateFields } from "web/utils/system/formValidator/validation";

import {
  FormView,
  ISubscriptionFormData,
  ISubscriptionReceiverFormField,
  ISubscriptionReceiverFormValues,
} from "web/types/Subscription";

interface ISimpleFormProps {
  fields: ISubscriptionReceiverFormField[];
  nameFieldsDisabled: boolean;
  formData: ISubscriptionFormData;
  submitHandler: (values: ISubscriptionReceiverFormValues) => void;
  closeHandler: () => void;
  isMobile: boolean;
  onDirtyChange: (isDirty: boolean) => void;
  viewType: FormView;
}

const SimpleFormMUI: FC<ISimpleFormProps> = ({
  fields,
  nameFieldsDisabled = false,
  formData,
  submitHandler,
  closeHandler,
  isMobile,
  onDirtyChange,
  viewType,
}) => {
  if (!isArrayHasItems(fields)) return null;

  const [initialValues, fieldsToValidate] = useMemo(
    () => getInitialValues(fields, formData),
    [fields]
  );

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const validate = validateFields(fieldsToValidate);

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues as ISubscriptionReceiverFormValues}
      onSubmit={submitHandler}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      validate={validate}
    >
      {({ dirty }) => {
        useEffect(() => {
          onDirtyChange(dirty);
        }, [dirty]);

        return (
          <Form noValidate>
            {fields.map((field) => {
              return (
                <FieldMUI
                  required={field.required}
                  key={field.type}
                  label={field.label}
                  name={field.id}
                  dataT1={field.type}
                  sx={{ mb: 0 }}
                  {...getFieldSpecificProps(field.type, nameFieldsDisabled)}
                />
              );
            })}
            <Divider sx={{ mt: 2, mb: 1 }} />
            {fields.some((field) => field.required) ? (
              <Box>
                <Typography>*{__("Pola są wymagane")}</Typography>
                <Divider sx={{ pt: 3 }} />
              </Box>
            ) : null}

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                size="large"
                onClick={closeHandler}
                fullWidth={isMobile}
                sx={{ mr: 1, order: isMobile ? 1 : 0, mt: isMobile ? 2 : 0 }}
              >
                {__("Anuluj")}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                fullWidth={isMobile}
                sx={{ order: isMobile ? 0 : 1 }}
              >
                {viewType === FormView.MY_SUBSCRIPTIONS
                  ? __("Zapisz zmiany")
                  : __("Zapisz i zamknij")}
              </Button>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SimpleFormMUI;
